import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { pageURLs } from "@/constants";
import { useBuyerFormLink } from "@/hooks/useBuyerFormLink";
import { useFormRequests } from "@/hooks/useFormRequests";
import useAgentGitchaRestrictions from "@/hooks/useAgentGitchaRestrictions";
import { isWaitingRequest } from "@/components/NewRequestLine";
import { useMLSAgentAtGitchaRedirect } from "@/hooks/useMLSAgentAtGitchaRedirect";
import "./CreateWantListingStart.scss";

export const draftsLabel = (waiting) => (waiting > 0 ? `${waiting} to review` : "");

export const CreateWantListingStartView = ({
  showBuyerForm,
  isPro,
  onSendForm,
  sendingForm,
  onOpenDrafts,
  onAddProperty = null,
  waiting = 0,
}) => (
  <header className="create-start">
    <h1 className="create-start__heading">Post a Buyer Want&#8209;Listing</h1>
    <nav className="create-start__links" aria-label="Other ways to post">
      {showBuyerForm ? (
        <button
          type="button"
          className="create-start__link"
          onClick={onSendForm}
          disabled={sendingForm}
          title={isPro === false ? "Included with Gitcha Pro" : undefined}
        >
          {isPro === false ? <Lock size={13} aria-hidden="true" /> : null}
          Send your buyer the form
          {isPro === false ? <span className="create-start__sr">, included with Gitcha Pro</span> : null}
        </button>
      ) : null}
      {showBuyerForm ? <span className="create-start__dot" aria-hidden="true" /> : null}
      <button type="button" className="create-start__link" onClick={onOpenDrafts}>
        Drafts
        {waiting > 0 ? <span className="create-start__waiting">{draftsLabel(waiting)}</span> : null}
      </button>
      {onAddProperty ? <span className="create-start__dot d-lg-none" aria-hidden="true" /> : null}
      {onAddProperty ? (
        <button type="button" className="create-start__link d-lg-none" onClick={onAddProperty}>
          Add a property
        </button>
      ) : null}
    </nav>
  </header>
);

const CreateWantListingStart = () => {
  const navigate = useNavigate();
  const { shouldRestrictAgent } = useAgentGitchaRestrictions();
  const { redirectToBLSEnv } = useMLSAgentAtGitchaRedirect();
  const buyerForm = useBuyerFormLink();
  const formRequests = useFormRequests(shouldRestrictAgent);
  const waiting = (formRequests.data || []).filter(isWaitingRequest).length;

  return (
    <>
      {buyerForm.modals}
      <CreateWantListingStartView
        showBuyerForm={!shouldRestrictAgent}
        isPro={buyerForm.isPro}
        onSendForm={buyerForm.send}
        sendingForm={buyerForm.sending}
        onOpenDrafts={() => navigate(`${pageURLs.agentMyWantAdListings}?status=draft`)}
        onAddProperty={() =>
          redirectToBLSEnv({
            path: pageURLs.agentCreateInventory,
            onGitchaEnvFallback: () => navigate(pageURLs.agentCreateInventory),
          })
        }
        waiting={waiting}
      />
    </>
  );
};

export default CreateWantListingStart;
